import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogContentText, Typography, Button, DialogActions } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function HelpMenu({ handleHelpDialogClose }) {
    return (
        <div>
            <Dialog
                open={true}
                onClose={handleHelpDialogClose}
                maxWidth="lg"
                fullWidth
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(5px)',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    }
                }}
                PaperProps={{
                    sx: {
                        maxHeight: '600px',
                        minHeight: '700px',
                        width: '800px',
                        m: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }
                }}
            >
            <DialogTitle className='text-navbar-options' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '23px', fontWeight: '700' }} id="help-dialog-title">Menu de ajuda</DialogTitle>
            <DialogContent>
                <DialogContentText id="help-dialog-description" sx={{ color: 'white' }}>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Criação de Cartões:
                        </AccordionSummary>
                        <AccordionDetails>
                            Os cartões são elementos primários para a organização de tarefas e informações. Eles podem ser totalmente customizados para incluir diversos tipos de dados. É possível adicionar <b>cores</b>, <b>capas</b>, <b>etiquetas</b>, <b>tarefas</b>, <b>subtarefas</b>, <b>comentários</b> e <b>anexar arquivos</b>. <br/>Essa flexibilidade os torna ferramentas robustas para detalhar e gerenciar o progresso de qualquer item. Para adicionar um cartão a uma lista, clique em <b>"+ ADICIONAR"</b>, localizado no final de cada lista.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Notas:
                        </AccordionSummary>
                        <AccordionDetails>
                            Você pode adicionar notas aos cartões para incluir informações rápidas e importantes, sem a necessidade de uma descrição completa. As notas ficam visíveis diretamente na parte frontal do cartão. Para criar uma nota, basta ir até o final de qualquer lista no quadro e clicar em <b>"+ ADICIONAR"</b>.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Listas do Quadro:
                        </AccordionSummary>
                        <AccordionDetails>
                            As listas servem para organizar seus cartões em colunas, dando uma visão clara do progresso do seu projeto. É fácil mover os cartões de uma lista para outra conforme a tarefa avança. Você também pode <u><i>arrastar</i></u> e <u><i>reordenar</i></u> as listas para organizá-las do jeito que preferir. Para adicionar uma nova lista ao seu quadro, basta clicar em <b>"+ ADICIONAR LISTA"</b> ao lado da última coluna.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Arquivamento de Cartões:
                        </AccordionSummary>
                        <AccordionDetails>
                            Você pode <b>arquivar cartões</b> para remover itens antigos ou concluídos do quadro principal, sem perdê-los. Eles ficam guardados para consulta quando necessário. Para ver ou esconder os cartões arquivados, basta usar o botão no menu.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Membros do Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            Os cartões podem ser atribuídos a membros específicos para definir responsabilidades e permitir a colaboração. Para atribuir um membro, basta entrar no cartão, selecionar o <b>"+"</b> correspondente a <b>Membros</b> e escolher o usuário que deseja associar. Para remover usuarios, apenas clique no icone pertencente e a remoção acontecerá.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Etiquetas do Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            As etiquetas ajudam a categorizar cartões com cores e descrições, facilitando a identificação visual. Para atribuir uma etiqueta, basta entrar no cartão, selecionar o <b>"+"</b> correspondente a <b>Etiquetas</b> e escolher a etiqueta que deseja associar. Para remover a estiqueta, selecione novamente. <br />Você tem um botão para criar uma nova etiqueta, que abrirá um pequeno modal onde você pode selecionar a cor, digitar o título e depois clicar em <b>"Criar"</b>. A etiqueta também possui um ícone de lápis para edição, onde você pode editar o título e a cor ou excluir a mesma, e um ícone de <b>"X"</b> onde pode remover a etiqueta clicando nele ou clicando novamente na etiqueta que está sendo usada.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Checklist do Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            Checklists são ideais para dividir tarefas complexas em passos menores. Eles funcionam como listas de verificação dentro do seu cartão, permitindo que você acompanhe o progresso de cada etapa. Para começar, entre no cartão, clique em <b>"Checklist"</b> no menu e dê um título à sua lista
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Tarefas do Checklist:
                        </AccordionSummary>
                        <AccordionDetails>
                            Após a criação de um checklist, você pode começar a adicionar as tarefas. Basta digitar o nome da tarefa no campo de texto que aparecerá e clicar em <b>"Adicionar"</b>. Assim, você pode criar uma lista completa e detalhada para acompanhar cada passo do seu projeto.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            SubTarefas em Tarefas:
                        </AccordionSummary>
                        <AccordionDetails>
                            A organização de tarefas complexas se torna muito mais fácil ao dividi-las em etapas menores. Dentro de uma tarefa existente, você pode adicionar subtarefas para quebrar um projeto em passos gerenciáveis. Por exemplo, a tarefa "Preparar o Lançamento de um Produto" pode ter as seguintes subtarefas: "Revisar o Texto do Site", "Criar Posts para Redes Sociais" e "Agendar o Webinar". <br />Isso permite que você acompanhe o progresso de cada etapa individualmente, garantindo que nenhum detalhe seja esquecido.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Anexos do Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            Os usuários podem adicionar arquivos e links como anexos aos cartões, mantendo todos os recursos relevantes em um só lugar. <br />Para adicionar um anexo, basta entrar no cartão, selecionar a opção correspondente a <b>'Anexar'</b> e escolher um arquivo. Você também pode adicionar um anexo através da Descrição.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Capa do Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            Os cartões podem ter uma capa, que é uma imagem ou cor para te dar uma ideia rápida do conteúdo, sem precisar abrir o cartão.

                            Para adicionar uma capa, basta entrar no cartão, selecionar a opção <b>"Capa"</b> no menu e escolher uma imagem ou cor. Se quiser remover, no mesmo lugar, você encontrará o botão <b>'Excluir capa'</b>.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Descrição do Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para incluir mais detalhes em um cartão, você pode usar a seção de <u><i>"descrição"</i></u>. Basta clicar em <b>"Editar"</b> para adicionar informações importantes sobre a tarefa ou item, como anotações, links ou qualquer outro dado relevante para o seu projeto.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Comentário:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para facilitar a comunicação e o acompanhamento das tarefas, você pode adicionar comentários aos cartões. Assim, é possível discutir detalhes, compartilhar atualizações e colaborar com outros membros. <br />Se quiser ir direto para o último comentário de um cartão, basta clicar no ícone de duas setas, ao lado do título 'Atividade'.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Cartões - Nome Alterável:
                        </AccordionSummary>
                        <AccordionDetails>
                            O nome de cada cartão pode ser alterado a qualquer momento para refletir mudanças na tarefa. Para fazer isso, entre no cartão e clique diretamente sobre o nome para editá-lo.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Conta:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para acessar os detalhes da sua conta, clique no seu nome de usuário, que fica no topo da tela. No menu que se abre, selecione a opção <b>"Conta"</b>. Serão exibidas algumas informações, como o seu nome de usuário e o e-mail associado à conta.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Menu:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para abrir o menu, basta passar o mouse sobre o ícone de <b>"+"</b>, localizado no canto inferior direito da tela. Essa ação irá exibir todas as opções disponíveis, como gerenciar permissões, gerenciar membros.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Menu - Arquivados:
                        </AccordionSummary>
                        <AccordionDetails>
                            No menu, a opção <b>"Arquivados"</b> permite mostrar ou ocultar os cartões que foram arquivados. Isso ajuda a manter a visualização do seu quadro mais limpa, sem perder itens antigos ou concluídos, que podem ser consultados a qualquer momento.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Menu - Gerenciar Membros (disponível apenas para o criador ou administrador do quadro):
                        </AccordionSummary>
                        <AccordionDetails>
                            O menu do quadro inclui a opção <b>Gerenciar Membros</b>. Essa funcionalidade permite que você adicione ou remova colaboradores, garantindo que as pessoas certas tenham as permissões necessárias para visualizar e contribuir com o conteúdo do quadro.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Menu - Ajuda:
                        </AccordionSummary>
                        <AccordionDetails>
                            O Menu possui uma opção de Ajuda que fornece informações sobre como usar as diferentes funcionalidades da aplicação, facilitando o aprendizado e a utilização do sistema.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Fale Conosco:
                        </AccordionSummary>
                        <AccordionDetails>
                            O Menu possui uma opção de <u><i>Feedbacks</i></u> onde você pode enviar uma mensagem relatando um erro ou uma sugestão de melhoria.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Logout:
                        </AccordionSummary>
                        <AccordionDetails>
                            No menu, você encontrará a opção <b>"Logout"</b>, que permite sair da conta atual de forma segura, garantindo a privacidade dos seus dados.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Acessar Quadro:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para acessar um quadro que já existe, basta clicar sobre ele.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Criar Quadro:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para criar um quadro, basta clicar no botão <b>"CRIAR QUADRO"</b>. Em seguida, digite o nome e a descrição.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Plano de Fundo do Quadro:
                        </AccordionSummary>
                        <AccordionDetails>
                            Qualquer usuário pode personalizar a aparência do quadro alterando o plano de fundo. Para isso, clique no ícone ao lado do título do quadro. Lá, você poderá escolher uma nova cor para deixar o ambiente de trabalho com a sua cara.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Editar Quadro (disponível apenas para o criador ou administrador do quadro):
                        </AccordionSummary>
                        <AccordionDetails>
                            Para editar o nome ou a descrição do quadro, selecione a opção <b>"Editar Quadro"</b> no menu <b>"+"</b> e insira o novo nome e a nova descrição.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Exclusão de Quadro (disponível apenas para o criador do quadro):
                        </AccordionSummary>
                        <AccordionDetails>
                            Para excluir um quadro, passe o mouse sobre ele e clique no ícone  de três pontos. Em seguida, selecione a opção <b>"Excluir Quadro"</b>.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Permissões (disponível apenas para o criador e administradores do quadro):
                        </AccordionSummary>
                        <AccordionDetails>
                            Para conceder permissões a um membro do quadro, acesse o Menu e selecione <b>"Permissões"</b>. Você encontrará uma lista de membros sem permissão; clique em <b>"Tornar admin"</b> para conceder acesso. <br />Para revogar uma permissão, clique em <b>"Remover admin"</b> no mesmo local. Os administradores terão acesso aos menus de adicionar e remover membros, permissões e edição do quadro.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Copiar Cartão:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para copiar um cartão, entre no cartão que deseja duplicar e selecione a opção <b>"Copiar"</b>. Lá, você pode escolher quais atributos manter, alterar o nome do novo cartão ou manter o original e selecionar a lista de destino.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Copiar Lista:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para copiar uma lista inteira, basta clicar no ícone de três pontos no canto superior direito dela. Em seguida, selecione <b>"Copiar Lista"</b>, dê um novo nome e confirme a ação.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Renomear Lista:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para renomear uma lista, clique no ícone de três pontos no canto superior direito e selecione <b>"Editar Lista"</b>. Em seguida, digite o novo título e confirme a alteração.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Excluir Lista:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para excluir uma lista, clique no ícone de três pontos no canto superior direito dela e selecione <b>"Excluir Lista"</b>.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Tarefas com datas limites:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para adicionar uma data limite às tarefas do seu checklist, clique no ícone de relógio:
                            <br /><i>Amarelo</i>: Para datas que vencem hoje.
                            <br /><i>Vermelho</i>: Para tarefas atrasadas.
                            <br /><i>Cinza</i>: Para datas futuras.
                            <br /><i>Verde</i>: Para tarefas que já foram concluídas.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className='accordion'>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{ color: '#009373' }} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Detalhes do Cartão - Logs:
                        </AccordionSummary>
                        <AccordionDetails>
                            Para visualizar os detalhes do cartão, basta abrir o cartão desejado e, na seção <b>Atividades</b>, selecionar <b>'Mostrar Detalhes'</b>. Após isso, os logs do cartão aparecerão abaixo dos comentários.
                        </AccordionDetails>
                    </Accordion>
                    <div className='text-navbar-options'>
                        <br></br>
                        <strong>Não achou a solução desejada?</strong><br />
                        Procure um dos responsáveis pelo sistema.<br /><br />
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleHelpDialogClose}
                    className='button-navbar-options'
                    style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', width: '100px', cursor: 'pointer', height: '40px' }}
                >
                    Fechar
                </Button>
            </DialogActions>
            </Dialog>
        </div>
    );
}
